<template>
  <div class="page-container" v-wechat-title="titleTop" v-if="!showSuccessModal">
    <header class="header">
      <div class="header-content">
        <div class="close-btn" @click="goBack">
          <van-icon name="cross" size="20" />
        </div>
        <h1 class="page-title">行程评价</h1>
        <div class="header-spacer"></div>
      </div>
    </header>

    <main class="main-content">
      <van-skeleton title avatar :row="6" :loading="loading">
        
        <div class="user-section">
          <div class="avatar-wrapper">
            <img :src="data.icon || '/img/defaultIcon.jpg'" class="avatar-img" />
          </div>
          <div class="user-details">
            <h2 class="user-name">{{ data.nickName || '游客' }}</h2>
            <p class="boat-name">{{ data.boatName }}</p>
            <p class="trip-date">{{ formatDate(data.tripDate, 'yyyy.MM.dd') }}</p>
          </div>
        </div>

        <div class="rating-section">
          <div class="section-header">
            <h3 class="section-label">评分</h3>
            </div>

          <div class="rating-list">
            <div class="rating-item">
              <span class="rating-label">船只硬件</span>
              <div class="rating-dots">
                <div 
                  v-for="i in 5" :key="'s1'+i" 
                  class="dot-wrapper"
                  @click="handleRating('score1', i)"
                >
                  <div class="dot" :class="{ active: i <= data.score1 }"></div>
                </div>
              </div>
            </div>

            <div class="rating-item">
              <span class="rating-label">船员服务</span>
              <div class="rating-dots">
                <div 
                  v-for="i in 5" :key="'s2'+i" 
                  class="dot-wrapper"
                  @click="handleRating('score2', i)"
                >
                  <div class="dot" :class="{ active: i <= data.score2 }"></div>
                </div>
              </div>
            </div>

            <div class="rating-item">
              <span class="rating-label">行程餐食</span>
              <div class="rating-dots">
                <div 
                  v-for="i in 5" :key="'s3'+i" 
                  class="dot-wrapper"
                  @click="handleRating('score3', i)"
                >
                  <div class="dot" :class="{ active: i <= data.score3 }"></div>
                </div>
              </div>
            </div>

            <div class="rating-item">
              <span class="rating-label">潜导态度</span>
              <div class="rating-dots">
                <div 
                  v-for="i in 5" :key="'s4'+i" 
                  class="dot-wrapper"
                  @click="handleRating('score4', i)"
                >
                  <div class="dot" :class="{ active: i <= data.score4 }"></div>
                </div>
              </div>
            </div>

            <div class="rating-item">
              <span class="rating-label">行程性价比</span>
              <div class="rating-dots">
                <div 
                  v-for="i in 5" :key="'s5'+i" 
                  class="dot-wrapper"
                  @click="handleRating('score5', i)"
                >
                  <div class="dot" :class="{ active: i <= data.score5 }"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="comment-section">
          <div class="section-header">
            <h3 class="section-label">评论</h3>
            </div>
          
          <textarea
            v-model="data.about"
            :disabled="data.isLock"
            placeholder="分享你的体验与感受"
            class="custom-textarea"
          ></textarea>
          <p class="char-count">{{ data.about ? data.about.length : 0 }} / 500</p>
        </div>

        <div class="photo-section">
          <h3 class="section-label mb-5">照片</h3>
          
          <div class="photo-grid">
            <div v-for="(item, index) in fileList" :key="index" class="photo-item">
              <img :src="item.content || item.url" class="photo-img" />
              <div v-if="!data.isLock" class="delete-btn" @click="removePhoto(index)">
                <van-icon name="cross" size="12" />
              </div>
            </div>

            <div v-if="fileList.length < 20 && !data.isLock" class="upload-btn-wrapper">
              <van-uploader
                :after-read="afterRead"
                multiple
                :max-count="20"
                class="hidden-uploader"
              >
                <div class="add-btn">
                  <span class="plus-icon">+</span>
                </div>
              </van-uploader>
            </div>
          </div>
        </div>

      </van-skeleton>
    </main>

    <div class="footer-bar">
      <div class="footer-inner">
        <button 
          class="submit-btn" 
          :disabled="data.isLock || buttonLoading" 
          @click="onEdit"
        >
          <span v-if="buttonLoading">提交中...</span>
          <span v-else>{{ data.isLock ? errMeg : '提交评价' }}</span>
        </button>
      </div>
    </div>
  </div>

  <div v-else class="success-page">
    <div class="success-content">
      <h3 class="success-title">感谢您的评价</h3>
      <p class="success-desc">期待您的下一趟潜水旅程</p>
      </div>
  </div>
</template>

<script>
import request from '@/utils/request'
import { Button, Skeleton, Icon, Uploader } from 'vant'
import { compressorImageList, formatDate, MyNotify,GetDiveTitle } from '@/utils/base'

export default {
  name: 'LiveaboardComment',
  components: {
    [Button.name]: Button,
    [Skeleton.name]: Skeleton,
    [Icon.name]: Icon,
    [Uploader.name]: Uploader,
  },
  data() {
    return {
      titleTop:'',
      loading: true,
      hashCode: undefined,
      buttonLoading: false,
      errMeg: '评论已发布，无法修改',
      
      // UI 状态控制
      showSuccessModal: false,

      // 图片列表
      fileList: [],

      // 核心数据 (保持旧结构)
      data: {
        score1: 0,
        score2: 0,
        score3: 0,
        score4: 0,
        score5: 0,
        about: '',
        icon: '',
        nickName: '',
        boatName: '',
        tripDate: new Date(),
        isLock: false,
      }
    }
  },
  created() {
    this.hashCode = this.$route.params.id
    this.titleTop = GetDiveTitle()
    this.onInit()
  },
  methods: {
    formatDate,
    goBack() {
      if(this.showSuccessModal) {
         // 如果已经成功，这里可以保留空操作，或者跳转
         return
      }
      window.history.back()
    },

    // --- 评分逻辑 ---
    handleRating(key, value) {
      if (this.data.isLock) return
      this.data[key] = value
    },

    // --- 图片逻辑 ---
    afterRead(file) {
      if (Array.isArray(file)) {
        this.fileList.push(...file)
      } else {
        this.fileList.push(file)
      }
    },
    removePhoto(index) {
      this.fileList.splice(index, 1)
    },

    // --- 数据初始化 ---
    onInit() {
      this.loading = true
      request({
        url: '/storeHelper/getLiveaboardCommentInfo',
        method: 'post',
        params: { code: this.hashCode }
      }).then(response => {
        this.loading = false
        this.titleTop = GetDiveTitle()
        if (!response.success) {
          MyNotify('error', response.message, 5000)
          this.data.isLock = true
          this.errMeg = response.message
          return
        }
        
        this.data = response.data
        
        // 图片回显处理
        if (this.data.urls && this.data.urls.length > 0) {
          this.fileList = this.data.urls.map(item => ({ url: item }))
        }
      })
    },

    // --- 核心提交逻辑 ---
    onEdit() {
      // 1. 校验锁定
      if (this.data.isLock) return

      // 2. 校验评分
      if (
        this.data.score1 <= 0 || 
        this.data.score2 <= 0 || 
        this.data.score3 <= 0 || 
        this.data.score4 <= 0 || 
        this.data.score5 <= 0
      ) {
        // 滚动到顶部
        window.scrollTo({ top: 0, behavior: 'smooth' })
        MyNotify('error', '请完成所有项目评分', 2000)
        return
      }

      // 3. 校验字数
      if (!this.data.about || this.data.about.length < 10) {
        MyNotify('error', '请填写最少10个字的评论', 2000)
        return
      }

      this.buttonLoading = true

      // 4. 上传图片 (复用旧逻辑)
      this.uploadImg(this.fileList, (urls) => {
        this.data.images = urls
        
        // 5. 提交数据
        request({
          url: '/storeHelper/UpdateLiveaboardCommentInfo',
          method: 'post',
          data: this.data
        }).then(response => {
          this.buttonLoading = false
          if (!response.success) {
            MyNotify('error', response.msg || '提交失败', 2000)
            return
          }
          
          this.data.isLock = true
          this.showSuccessModal = true
        })
      })
    },

    // --- 图片压缩上传 (旧核心逻辑) ---
    uploadImg(files, callback) {
      var noFile = true
      var fileListToUpload = []
      
      files.map((value) => {
        if (value.file) { // 新选择的图片才有 file 对象
          fileListToUpload.push(value.file)
          noFile = false
        }
      })

      if (noFile) {
        if (callback) {
          // 过滤出旧图片
          const oldUrls = this.fileList.filter(v => !v.file).map(v => v.url || v.content)
          callback(oldUrls.toString())
        }
        return
      }

      compressorImageList(fileListToUpload, 2048, 2048, 0.6, (list) => {
        const formData = new FormData()
        list.map((value) => {
          if (value.name) {
            formData.append('file', value.file, value.name)
          } else {
            formData.append('file', value.file)
          }
        })
        
        request({
          url: '/Data/uploadFile?config=liveaboardcomment',
          method: 'post',
          data: formData
        }).then(response => {
          if (!response.success) {
            this.buttonLoading = false
            MyNotify('error', '图片上传失败')
            return
          }
          
          var finalUrls = []
          // 1. 先加入原有的旧图片
          this.fileList.forEach(value => {
            if (!value.file) {
              finalUrls.push(value.url)
            }
          })
          // 2. 再加入新上传成功的图片
          response.data.forEach(value => {
            finalUrls.push(value.save)
          })

          if (callback) {
            callback(finalUrls.toString())
          }
        })
      })
    }
  }
}
</script>

<style scoped>
/* Reset & Base */
* { box-sizing: border-box; }
.page-container {
  min-height: 100vh;
  background-color: #ffffff;
  padding-bottom: 6rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  color: #171717;
}

/* Header */
.header {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(229, 229, 229, 0.6);
  position: sticky;
  top: 0;
  z-index: 40;
}
.header-content {
  max-width: 32rem;
  margin: 0 auto;
  height: 3.5rem;
  padding: 0 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.close-btn {
  padding: 0.25rem;
  margin-left: -0.25rem;
  cursor: pointer;
  color: #171717;
}
.page-title {
  font-size: 0.875rem;
  font-weight: 500;
  color: #2563eb; /* blue-600 */
  letter-spacing: 0.05em;
  margin: 0;
}
.header-spacer { width: 1.5rem; }

/* Main Content */
.main-content {
  max-width: 32rem;
  margin: 0 auto;
  padding: 0 1.5rem;
}

/* User Section */
.user-section {
  padding: 1.5rem 0;
  border-bottom: 1px solid rgba(229, 229, 229, 0.6);
  display: flex;
  align-items: flex-start;
  gap: 1rem;
}
.avatar-wrapper {
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  overflow: hidden;
  background-color: #f5f5f5;
  flex-shrink: 0;
}
.avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.user-details {
  padding-top: 0.125rem;
}
.user-name {
  font-size: 1rem;
  font-weight: 500;
  color: #171717;
  margin: 0 0 0.125rem 0;
}
.boat-name {
  font-size: 0.875rem;
  color: #737373;
  margin: 0 0 0.125rem 0;
}
.trip-date {
  font-size: 0.75rem;
  color: #a3a3a3;
  letter-spacing: 0.025em;
  margin: 0;
}

/* Rating Section */
.rating-section {
  padding: 2rem 0 1.5rem 0;
  border-bottom: 1px solid rgba(229, 229, 229, 0.6);
}
.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}
.section-label {
  font-size: 0.75rem;
  font-weight: 500;
  letter-spacing: 0.1em;
  color: #2563eb;
  text-transform: uppercase;
  margin: 0;
}
.rating-list {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}
.rating-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.rating-label {
  font-size: 0.875rem;
  font-weight: 300;
  color: #171717;
  letter-spacing: 0.025em;
}
.rating-dots {
  display: flex;
  gap: 0.75rem;
}
.dot-wrapper {
  padding: 0.25rem;
  cursor: pointer;
}
.dot {
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  background-color: #e5e5e5;
  transition: all 0.2s;
}
.dot.active {
  background-color: #2563eb;
  transform: scale(1.25);
}

/* Comment Section */
.comment-section {
  padding: 2rem 0 1.5rem 0;
  border-bottom: 1px solid rgba(229, 229, 229, 0.6);
}
.custom-textarea {
  width: 100%;
  min-height: 7rem;
  background-color: rgba(249, 250, 251, 0.5); /* bg-neutral-50/50 */
  border: none;
  padding: 0.75rem 1.25rem;
  font-size: 0.875rem;
  font-weight: 300;
  line-height: 1.6;
  color: #171717;
  resize: none;
  outline: none;
}
.custom-textarea::placeholder {
  color: #a3a3a3;
}
.char-count {
  font-size: 0.75rem;
  color: #a3a3a3;
  margin-top: 0.75rem;
  letter-spacing: 0.025em;
}

/* Photo Section */
.photo-section {
  padding-top: 2rem;
}
.mb-5 { margin-bottom: 1.25rem; }
.photo-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.5rem;
}
.photo-item {
  position: relative;
  aspect-ratio: 1 / 1;
  background-color: #f5f5f5;
}
.photo-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.delete-btn {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  width: 1.5rem;
  height: 1.5rem;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(2px);
  border-radius: 0; /* Square-ish as per design */
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.upload-btn-wrapper {
  aspect-ratio: 1 / 1;
  border: 1px solid rgba(229, 229, 229, 0.8);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
  background-color: white;
}
.upload-btn-wrapper:hover {
  background-color: rgba(249, 250, 251, 0.5);
  border-color: #d4d4d4;
}
.add-btn {
  width: 2rem;
  height: 2rem;
  border: 1px solid #d4d4d4;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.plus-icon {
  font-size: 1.125rem;
  font-weight: 300;
  color: #a3a3a3;
  margin-top: -2px;
}
/* 隐藏 Vant Uploader 默认样式 */
.hidden-uploader >>> .van-uploader__upload {
  display: none;
}
.hidden-uploader >>> .van-uploader__wrapper {
  display: block;
}

/* Footer Bar */
.footer-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(12px);
  border-top: 1px solid rgba(229, 229, 229, 0.6);
  z-index: 50;
}
.footer-inner {
  max-width: 32rem;
  margin: 0 auto;
  padding: 1.25rem 1.5rem;
}
.submit-btn {
  width: 100%;
  height: 3rem;
  background: linear-gradient(to right, #2563eb, #3b82f6);
  color: white;
  font-size: 0.875rem;
  font-weight: 300;
  letter-spacing: 0.05em;
  border: none;
  border-radius: 0;
  transition: all 0.2s;
}
.submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Success Page */
.success-page {
  position: fixed;
  inset: 0;
  z-index: 50;
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-top: 40vh;
  box-sizing: border-box;
  animation: fadeIn 0.5s ease-out;
}
.success-content {
  text-align: center;
  animation: slideUp 0.7s ease-out;
}
.success-title {
  font-size: 1.5rem;
  font-weight: 300;
  color: #171717;
  letter-spacing: 0.025em;
  margin-bottom: 0.75rem;
}
.success-desc {
  font-size: 0.875rem;
  color: #737373;
  letter-spacing: 0.05em;
  margin-bottom: 0;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}
@keyframes slideUp {
  from { transform: translateY(1rem); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}
</style>